import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthResolver implements Resolve<any> {
  constructor(
    private router: Router,
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {

    const token = localStorage.getItem('token');
    const validToken = (token !== null && (typeof token !== 'undefined'));

    if (validToken) {
      this.router.navigate(['home']);
    }
    return of(true);
  }
}
